import React, {useState} from 'react';
import DefaultFooter from "./EventTagFooter";
import {
  AppFooter,
} from "@coreui/react";
import {Container} from "reactstrap";
import './event.scss';
import QRCode from 'qrcode';
import logo from "../../assets/img/logos/md-logo.png"

const App = () => {
  const params = new URLSearchParams(window.location.search);
  const [url, setUrl] = useState("");

  if(params.has("id")) {
    let id = params.get("id");
    let id_array = id.split("_");
    console.log("id_array: ", id_array)
    let mobile_array = id_array[0].split("@");
    let mobile = mobile_array[1]+""+mobile_array[0];
    console.log("Mobile: ", mobile)
    QRCode.toDataURL(mobile,{ scale: 8 })
      .then(url => {
        setUrl(url);
      })
      .catch(err => {
        console.error(err)
      })
  }

  return (
    <div className="app event-app-download-wrapper">
      <div className="app-body">

        <main className="main margin-left239">
          <Container fluid>

            <div id="myModal" className="modal-wrapper">
              <div className="modal-dialog modal-confirm">
                <div className="modal-content">
                  <div className="modal-header">
                    <div className="icon-box">
                      <img src={logo} alt="play-store-badge"/>
                    </div>
                    <br/>
                  </div>
                  <div className="modal-body text-center p-0">
                    {
                      url!=""?
                      <img src={url} alt=""/>
                      :
                        <div>

                          <span style={{color: "red", fontSize: "20px"}}>
                            <br/>
                            <br/>
                            <br/>
                            Sorry! <br/>
                            Unable to generate the QR
                            <br/>
                            <br/>
                            <br/>
                          </span>

                        </div>
                    }
                  </div>
                  {
                    url!=""?
                    <div className="modal-footer">
                      Show this QR to the volunteers at the event venue for checkin.
                    </div>
                      :
                      null
                  }
                </div>
              </div>
            </div>

          </Container>
        </main>

      </div>

      <AppFooter>
        <DefaultFooter ROLE={""} class={"ml-none"}/>
      </AppFooter>

    </div>
  )
};
export default App;
